/// <amd-module name="TFS/DRITools/util/IdentityService" />
import { IdentitiesGetMruRequestModel, IdentitiesSearchRequestModel, IEntity } from "TFS/DRITools/Contracts/IdentityPicker.d";
import { IIdentityPickerHttpClient } from "TFS/DRITools/RestClient/IdentityPicker";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export const IdentityServiceName = "IIdentityService";

export interface IIdentityService extends IVssService {
    getIdentityMruAsync(): Promise<IEntity[]>;
    searchIdentitiesAsync(searchFilter: string): Promise<IEntity[]>;
}

export interface IItem {
    value: string;

    /** Optional label to display instead of the value */
    label?: string;

    /** Optional classname to apply to rendered item */
    className?: string;
}

const defaultProperties = ["DisplayName", "IsMru", "ScopeName", "SamAccountName", "Active", "SubjectDescriptor"];
const defaultUserProperties = [
    "Department",
    "JobTitle",
    "Mail",
    "MailNickname",
    "PhysicalDeliveryOfficeName",
    "SignInAddress",
    "Surname",
    "Guest",
    "TelephoneNumber"
];
const defaultGroupProperties = ["Description"];
const defaultQueryProperties = defaultProperties.concat(defaultUserProperties).concat(defaultGroupProperties);

export class IdentityService extends VssService implements IIdentityService {
    private _cachedMru?: IEntity[];
    private _identityPickerClient: IIdentityPickerHttpClient;

    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);
        this._identityPickerClient = pageContext.getRestClient<IIdentityPickerHttpClient>("IIdentityPickerHttpClient");
    }

    public _serviceEnd(pageContext: IVssPageContext) {
        super._serviceEnd(pageContext);
        delete this._cachedMru;
    }

    public async getIdentityMruAsync(): Promise<IEntity[]> {
        if (this._cachedMru) {
            return this._cachedMru;
        }

        const requestParams: IdentitiesGetMruRequestModel = {
            operationScopes: ["ims", "source"],
            properties: ["DisplayName"]
        };

        const mru = await this._identityPickerClient.beginGetIdentityFeatureMru("me", "common", requestParams);
        this._cachedMru = mru.mruIdentities;
        return this._cachedMru;
    }

    public async searchIdentitiesAsync(searchFilter: string): Promise<IEntity[]> {
        const requestProps: IdentitiesSearchRequestModel = {
            query: searchFilter,
            identityTypes: ["user"],
            operationScopes: ["ims", "source"],
            options: {
                MinResults: 39,
                MaxResults: 40
            },
            properties: defaultQueryProperties
        };
        const result = await this._identityPickerClient.beginGetIdentities(requestProps);
        return result.results[0].identities;
    }
}

Services.add(IdentityServiceName, { serviceFactory: IdentityService });
